// @ts-nocheck
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@rsuite/icons/Menu';
import GridIcon from '@rsuite/icons/Grid';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import { useNavigate } from 'react-router-dom';
import SortUpIcon from '@rsuite/icons/SortUp';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import { useInView } from 'react-intersection-observer';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import PushMessageIcon from '@rsuite/icons/PushMessage';
import FunnelIcon from '@rsuite/icons/Funnel';
import SortDrawer from '../tables/members/SortDrawer';
import './style.css';
import {
  Input,
  InputGroup,
  Table,
  Button,
  ButtonGroup,
  CheckPicker,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Modal,
  Col,
  ButtonToolbar,
  FlexboxGrid,
  Tooltip,
  IconButton,
  Whisper,
  Drawer,
  Pagination,
  Loader,
  TagPicker,
  SelectPicker,
  Message,
  useToaster,
  Dropdown,
  Container,
  Popover
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import axios from 'axios';
import ugr from '../../UGRoute';
import HeaderFilter from '@/components/HeaderFilter';
import FilterDrawer from '@/components/FilterDrawer';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '@/apiService/apiService';
import useFilters from '../tables/members/Filters';
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: 'Inch';
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    Variant_Id: string;
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    ProductionDetail: [
      {
        id: string;
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: 0;
        MaterialCode: string;
        MaterialFinishCode: string;
      }
    ];
    // Add other attributes if needed
  };
}

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const { HeaderCell, Cell } = Table;

const ProductSelectionPage = () => {
  const ipp = globalIP;
  // const [data, setData] = React.useState(defaultData);
  const [data123, setData123] = useState<RowData[]>([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [progress, setProgress] = useState(0);
  const [isLoadingTableData, SetIsLoadingTableData] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableMeta, setTableMeta] = useState();
  const [reload, setReload] = useState(false);
  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${500}px 0px`
  });

  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  let setSearchQryBtn = false;
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDateRange, setSelectedDateRange] = useState(null);

  function searchQry() {
    if (searchQuery !== '') {
      setData123([]);
      setSearchQryBtn = true;
      fetchData();
    }
  }
  useEffect(() => {
    setCurrentPage(1);
    if (searchQuery === '') {
      setData123([]);
      setCurrentPage(1);
      setSearchQryBtn = false;
      fetchData();
    }
    setSearchQryBtn = false;
  }, [searchQuery]);
const [alsort, setAlsort] = useState('A');
  useEffect(() => {
    if (!setSearchQryBtn) {
      setSearchQuery('');
    }
    fetchData();
    setCurrentPage(1);
  }, [
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku,
    alsort
  ]);
  const [limit, setLimit] = useState(0);
  const [page, setPage] = useState(1);
  
  const fetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(color => `filters[ColorCode][$eq]=${color}`)
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }

    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail[0].MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }

    let showpFilter = `&filters[Authorized][$eq]=Authorised`;
    let datefilter = '';
    let updateddatefilter = '';

    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
    const endOfToday = new Date(); // Current time

    switch (selectedDateRange) {
      case 'Today':
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;

      case 'This week':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        datefilter = '';
        break;
    }

    switch (selectedUpdatedDateRange) {
      case 'Today':
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;

      case 'This week':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        updateddatefilter = '';
        break;
    }
    let showsort = 'id:desc';
    if (alsort == 'B') {
      showsort = 'id:asc';
    } else if (alsort == 'C') {
      showsort = 'ProductId:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductId:desc';
    } else if (alsort == 'F') {
      showsort = 'ProductCost:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductCost:desc';
    } else if (alsort === 'G') {
      showsort = 'AuthDate:desc'; // Authorized Newest First
    } else if (alsort === 'H') {
      showsort = 'AuthDate:asc'; // Authorized Oldest First
    }
    const response = await fetch(
      `${ipp}/api/products?populate=*&sort[0]=${showsort}&pagination[page]=${currentPage}${categoryFilter}${protypeFilter}${colorFilter}${searchQryFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${searchQryFilter}${showpFilter}&${updateddatefilter}&${datefilter}`
    );
    const json = await response.json();
    setLimit(json.data.length);

    if (currentPage === 1) {
      setData123(json.data);
    } else {
      setData123(prevData => [...prevData, ...json.data]);
      SetIsLoadingTableData(false);
    }
    setMeta123(json.meta);
    setIsLoading(false);
  };

  const TableFetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(color => `filters[ColorCode][$eq]=${color}`)
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail[0].MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
      searchQryFilter = `&${searchQry}`;
    }

    let showpFilter = `&filters[Authorized][$eq]=Authorised`;
    let showsort = 'id:desc';
    if (alsort == 'B') {
      showsort = 'id:asc';
    }
    if (alsort == 'C') {
      showsort = 'ProductId:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductId:desc';
    } else if (alsort == 'F') {
      showsort = 'ProductCost:asc';
    } else if (alsort == 'D') {
      showsort = 'ProductCost:desc';
    }
    const response = await fetch(
      `${ipp}/api/products?populate=*&sort[0]=${showsort}&pagination[page]=${page}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${showpFilter}${searchQryFilter}`
    );
    const json = await response.json();
    setTableData(json.data);
    setTableMeta(json.meta);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    TableFetchData();
  }, [page, reload]);
  useEffect(() => {
    TableFetchData();
  }, [alsort]);
  const [allFetchedData, setAllFetchedData] = useState<RowData[]>([]);

  useEffect(() => {
    fetchAllData();
  }, []);
  const fetchAllData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const response = await fetch(`${ipp}/api/products?populate=*&pagination[page]=1`);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(`${ipp}/api/products?populate=*&pagination[page]=${page}`);
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setAllFetchedData(allData);
    setIsLoading(false);
  };

  const [checkedKeys, setCheckedKeys] = useState<number[]>([]);
  const [showtab, setShowtab] = useState(1);
  const [showDrawer, setShowDrawer] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [size, setSize] = React.useState();
  const [modeldata, setmodeldata] = React.useState([]);
  const [multipleImages, setMultipleImages] = useState([]);
  const handleClose = () => setOpen(false);
  let checked = false;
  let indeterminate = false;
  if (checkedKeys.length === data123.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < data123.length) {
    indeterminate = true;
  }

  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(true);
  const handleClick1 = () => {
    setIsActive1(!isActive1);
    setIsActive2(false);
  };

  const handleClick2 = () => {
    setIsActive1(isActive2);
    setIsActive2(true);
  };
  const tooltip = <Tooltip>List View</Tooltip>;
  const tooltip1 = <Tooltip>Grid View</Tooltip>;
  const ip = ipp;

  const handleEditRow = rowData => {
    setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedData(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
  };

  const handleSaveRow = async (rowId: string) => {
    try {
      const rowData = data123.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData: RowData = {
        ...rowData,
        attributes: { ...rowData.attributes, ...editedData[rowId] }
      };
      delete updatedRowData.attributes.CoverImage;
      delete updatedRowData.attributes.MultipleImage;
      const response = await fetch(`${ipp}/api/products/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });
      if (response.ok) {
        fetchData();
        setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowId));
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const toaster = useToaster();
  const handleInputChange = (rowId, fieldName, value) => {
    const productId = value;

    const isExistingProductId = data123.some(
      item => item.attributes.ProductId === productId && item.id !== rowId
    );

    if (isExistingProductId) {
      toaster.push(
        <Message showIcon type="error">
          Alias Code Already Exist.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...data123.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  const handleInputChange2 = (rowId, fieldName, fieldCode, value, data) => {
    const selectedData = data.find(item => item.label === value);
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...data123.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      updatedData[rowId][fieldCode] = selectedData ? selectedData.value : '';
      return updatedData;
    });
  };

  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc, SetIsLoadingTableData, setProgress);
  }, []);

  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    // console.log('colordata', colordata);
  }, [colordata]);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(setProductypedata, isLoadingpro, setIsLoadingpro, selectedCategoryCode);
    }
  }, [selectedCategoryCode]);

  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchFinishes(setFinishdata, isLoadingfin, setIsLoadingfin);
  }, []);

  const [materialdata, setMaterialdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat);
  }, []);

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);

  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);
  const [displayedData, setDisplayedData] = useState([]);
  const itemsPerPage = 100;
  // const observer = useRef();

  useFilters(
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedAlias,
    setAliasdata,
    setFinishdata,
    setColordata,
    setCategorydata,
    setProductypedata
  );
  useEffect(() => {
    // console.log('productypedata', productypedata);
  }, [productypedata]);
  useEffect(() => {
    // console.log('categorydata', categorydata);
  }, [categorydata]);
  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias);
  }, []);

  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadinsku);
  }, []);

  // const [searchQuery, setSearchQuery] = useState('');

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    fetchData(); // Your data fetching function
    TableFetchData(); // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  const handleCategoryChange = value => {
    setCurrentPage(1);
    setReload(prev => !prev);
    setPage(1);
    setSelectedCategory(value);
    setSelectedCategoryCode(value);
  };

  const handleProductTypeChange = value => {
    setPage(1);
    setReload(prev => !prev);
    setCurrentPage(1);
    setSelectedProductType(value);
  };
  const handleColorChange = value => {
    setReload(prev => !prev);
    setPage(1);
    setCurrentPage(1);

    setSelectedColor(value);
  };
  const handleMaterialChange = value => {
    // handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
    setReload(prev => !prev);
    setPage(1);
    setCurrentPage(1);

    setMaterialdata(value);
  };
  const handleFinishChange = value => {
    setReload(prev => !prev);
    setPage(1);
    setCurrentPage(1);
    setSelectedFinish(value);
  };

  const handleHSNChange = value => {
    setCurrentPage(1);

    setPage(1);
    setReload(prev => !prev);
    setSelectedhsn(value);
  };

  const handleBuyerChange = value => {
    setPage(1);
    setCurrentPage(1);

    setReload(prev => !prev);
    setSelectedBuyer(value);
  };
  const handleSearchChange = value => {
    setPage(1);
    setCurrentPage(1);

    setReload(prev => !prev);
    setSelectedSearch(value);
  };
  const handleAliasChange = value => {
    setPage(1);
    setCurrentPage(1);

    setReload(prev => !prev);
    setSelectedAlias(value);
  };
  const handleProNameChange = value => {
    setPage(1);
    setCurrentPage(1);

    setReload(prev => !prev);
    setSelectedPron(value);
  };
  const handleProDChange = value => {
    setPage(1);
    setReload(prev => !prev);
    setCurrentPage(1);

    setSelectedProd(value);
  };
  const handleMadeChange = value => {
    setPage(1);
    setReload(prev => !prev);
    setCurrentPage(1);

    setSelectedMade(value);
  };
  const handleSkuChange = value => {
    setPage(1);
    setReload(prev => !prev);
    setCurrentPage(1);

    setSelectedSku(value);
  };
  const [hoveredImage, setHoveredImage] = useState(null);

  const history = useNavigate();
  const handleNavigate = async item => {
    console.log('item', item);
    const req = await fetch(
      `${globalIP}/api/costings?populate=*&filters[ProductId][$eq]=${item.id}&filters[prdcd][$eq]=${item.attributes.ProductCode}`
    );
    const res = await req.json();

    if (
      res.data[0]?.attributes.CostingMaterial.length > 0 &&
      res.data[0]?.attributes.CostingWood.length > 0
    ) {
      let tempitem = item;
      const tempprddetail = tempitem.attributes.ProductionDetail.filter(item => {
        materialdata.find(material => material.label == item.MaterialNm)?.type !==
          ('cmaterial' || 'wmaterial' || 'mrmaterial');
      });
      tempitem.attributes.ProductionDetail = tempprddetail;
      history(`/${ugr}/costing`, { state: { ...tempitem, costingFor, isEdit: true } });
    } else if (res.data[0]?.attributes.CostingMaterial.length > 0) {
      let tempitem = item;
      const tempprddetail = tempitem.attributes.ProductionDetail.filter(item => {
        materialdata.find(material => material.label == item.MaterialNm)?.type !== 'cmaterial';
      });
      tempitem.attributes.ProductionDetail = tempprddetail;
      history(`/${ugr}/costing`, { state: { ...tempitem, costingFor, isEdit: true } });
    } else if (res.data[0]?.attributes.CostingWood.length > 0) {
      let tempitem = item;
      const tempprddetail = tempitem.attributes.ProductionDetail.filter(item => {
        materialdata.find(material => material.label == item.MaterialNm)?.type !==
          ('wmaterial' || 'mrmaterial');
      });
      tempitem.attributes.ProductionDetail = tempprddetail;
      history(`/${ugr}/costing`, { state: { ...tempitem, costingFor, isEdit: true } });
    } else {
      history(`/${ugr}/costing`, { state: { ...item, costingFor, isEdit: true } });
    }
  };
  const handleEditAllRowCategory = rowData => {
    const encodedData = encodeURIComponent(JSON.stringify(rowData));
    history(`/${ugr}/products-create?selectedItemId=${encodedData}&id=${rowData.id}`);
  };
  const pid = id => {
    history(`/${ugr}/products-create?pId=${id}&id=${id}`);
  };
  const [open1, setOpen1] = React.useState(false);
  const [size1, setSize1] = React.useState();
  const handleOpen1 = value => {
    setSize1(value);
    setOpen1(true);
  };
  const handleClose1 = () => setOpen1(false);

  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const handleDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1);
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchHeads(setHead);
  }, []);
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [sizeshow, setSizeShow] = useState(false);
  const [sort, setSort] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
      setSort(json.data[0].attributes.SortBy);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const defaultColumns = [
    {
      key: 'Image',
      label: 'Image',
      fixed: true,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );

            return (
              <Whisper
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${ipp}${rowData.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${ipp}${rowData.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },

    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductId || ''}
                onChange={value => handleInputChange(rowData.id, 'ProductId', value)}
              />
            ) : (
              rowData.attributes.ProductId
            )
          }
        </Cell>
      )
    },

    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 300,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Description || ''}
                onChange={value => handleInputChange(rowData.id, 'Description', value)}
              />
            ) : (
              rowData.attributes.Description
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 250,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductName || ''}
                onChange={value => handleInputChange(rowData.id, 'ProductName', value)}
              />
            ) : (
              rowData.attributes.ProductName
            )
          }
        </Cell>
      )
    },

    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            sizeshow ? (
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.SizeRange || ''}
                  onChange={value => handleInputChange(rowData.id, 'SizeRange', value)}
                />
              ) : (
                rowData.attributes.SizeRange
              )
            ) : (
              `${rowData.attributes.Length} x ${rowData.attributes.Width} x ${rowData.attributes.Height} ${rowData.attributes.SizeUnit}`
            )
          }
        </Cell>
      )
    },

    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={finishdata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.FinishName || ''}
                onChange={value =>
                  handleInputChange2(rowData.id, 'FinishName', 'FinishCode', value, finishdata)
                }
              />
            ) : (
              rowData.attributes.FinishName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 150,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={colordata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ColorName || ''}
                onChange={value =>
                  handleInputChange2(rowData.id, 'ColorName', 'ColorCode', value, colordata)
                }
              />
            ) : (
              rowData.attributes.ColorName
            )
          }
        </Cell>
      )
    },

    {
      key: 'cbm',
      label: `${label[0]?.attributes.cbm}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.cbm}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.cbm || ''}
                onChange={value => handleInputChange(rowData.id, 'cbm', value)}
                readOnly
              />
            ) : (
              rowData.attributes.cbm
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProductCost',
      label: `${label[0]?.attributes.SalePriceINR}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.SalePriceINR}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductCost || ''}
                onChange={value => handleInputChange(rowData.id, 'ProductCost', value)}
              />
            ) : (
              rowData.attributes.ProductCost
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProductCode',
      label: 'ProductCode',
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>P. Code</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductCode || ''}
                onChange={value => handleInputChange(rowData.id, 'ProductCode', value)}
                readOnly
              />
            ) : (
              rowData.attributes.ProductCode
            )
          }
        </Cell>
      )
    },
    {
      key: 'Category',
      label: `${label[0]?.attributes.Category}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Category}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={categorydata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.CategoryName || ''}
                onChange={value =>
                  handleInputChange2(
                    rowData.id,
                    'CategoryName',
                    'CategoryCode',
                    value,
                    categorydata
                  )
                }
              />
            ) : (
              rowData.attributes.CategoryName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProductType',
      label: `${label[0]?.attributes.ProductType}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductType}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={productypedata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ProductTypeName || ''}
                onChange={value =>
                  handleInputChange2(
                    rowData.id,
                    'ProductTypeName',
                    'ProductTypeCode',
                    value,
                    productypedata
                  )
                }
              />
            ) : (
              rowData.attributes.ProductTypeName
            )
          }
        </Cell>
      )
    },
    {
      key: 'NetWeight',
      label: `${label[0]?.attributes.NetWgt}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.NetWgt}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.NetWeight || ''}
                onChange={value => handleInputChange(rowData.id, 'NetWeight', value)}
              />
            ) : (
              rowData.attributes.NetWeight
            )
          }
        </Cell>
      )
    },
    {
      key: 'GrossWeight',
      label: `${label[0]?.attributes.GrossWgt}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.GrossWgt}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.GrossWeight || ''}
                onChange={value => handleInputChange(rowData.id, 'GrossWeight', value)}
              />
            ) : (
              rowData.attributes.GrossWeight
            )
          }
        </Cell>
      )
    },
    {
      key: 'HSNCode',
      label: `${label[0]?.attributes.HSN}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.HSN}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={hsndata}
                value={editedData[rowData.id]?.HSNCode || ''}
                onChange={value => handleInputChange(rowData.id, 'HSNCode', value)}
              />
            ) : (
              rowData.attributes.HSNCode
            )
          }
        </Cell>
      )
    },
    {
      key: 'MOQ',
      label: `${label[0]?.attributes.MOQ}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.MOQ}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.MOQ || ''}
                onChange={value => handleInputChange(rowData.id, 'MOQ', value)}
              />
            ) : (
              rowData.attributes.MOQ
            )
          }
        </Cell>
      )
    },
    {
      key: 'BuyerName',
      label: `${label[0]?.attributes.BuyerName}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.BuyerName}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={buyernamedata}
                value={editedData[rowData.id]?.BuyerName || ''}
                onChange={value => handleInputChange(rowData.id, 'BuyerName', value)}
              />
            ) : (
              rowData.attributes.BuyerName
            )
          }
        </Cell>
      )
    },
    {
      key: 'BuyerSku',
      label: `${label[0]?.attributes.BuyerSku}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.BuyerSku}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.BuyerSku || ''}
                onChange={value => handleInputChange(rowData.id, 'BuyerSku', value)}
              />
            ) : (
              rowData.attributes.BuyerSku
            )
          }
        </Cell>
      )
    },
    {
      key: 'Action',
      label: 'Action',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            let buyer;
            let factory;
            const data = costingAllData.filter(i => {
              return (
                i.attributes.prdcd == rowData.attributes.ProductCode &&
                i.attributes.ProductId == rowData.id
              );
            });

            costingFor.for == 'buyer'
              ? (buyer = data?.some(i => i.attributes?.costingfor == 'buyer') && (
                  <div className="tick"></div>
                ))
              : null;

            costingFor.for === 'factory'
              ? (factory = data?.some(i => i.attributes?.costingfor == 'factory') && (
                  <div className="tick2"></div>
                ))
              : null;

            return (
              <Button
                appearance="subtle"
                active
                onClick={() =>
                  history(`/${ugr}/costing`, { state: { ...rowData, costingFor, isEdit: true } })
                }
                style={{
                  marginLeft: '10px',
                  background: buyer ? 'rgb(0, 92, 128)' : factory ? 'rgba(0, 128, 0, 0.665)' : null,
                  color: buyer ? 'white' : factory ? 'white' : 'black'
                }}
              >
                Costing
              </Button>
            );
          }}
        </Table.Cell>
      )
    }
  ];
  const [columnKeys, setColumnKeys] = React.useState(
    defaultColumns
      .map(column => column.key)
      .filter(
        key =>
          key !== 'ProductCost' &&
          key !== 'ProductCode' &&
          key !== 'Category' &&
          key !== 'ProductType' &&
          key !== 'NetWeight' &&
          key !== 'GrossWeight' &&
          key !== 'HSNCode' &&
          key !== 'MOQ' &&
          key !== 'BuyerName' &&
          key !== 'BuyerSku'
      )
  );
  useEffect(() => {
    setColumnKeys(previousKeys => {
      if (sizeshow) {
        return [...previousKeys, 'SizeRange'];
      } else {
        return previousKeys.filter(key => key !== 'SizeRange');
      }
    });
  }, [sizeshow]);
  const [compact, setCompact] = useState(true);
  const [noData, setNoData] = useState(false);
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;

  const FixedLoader = () => (
    <Loader
      content="Loading..."
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        background: '#fff',
        width: '100%',
        padding: '4px 0'
      }}
    />
  );
  const renderMenu = menu => {
    return (
      <>
        {menu}
        {isLoadingse && <FixedLoader />}
      </>
    );
  };
  const renderMenu1 = menu => {
    return (
      <>
        {menu}
        {isLoadingalias && <FixedLoader />}
      </>
    );
  };
  const renderMenu2 = menu => {
    return (
      <>
        {menu}
        {isLoadingpron && <FixedLoader />}
      </>
    );
  };
  const renderMenu3 = menu => {
    return (
      <>
        {menu}
        {isLoadingprod && <FixedLoader />}
      </>
    );
  };
  const renderMenu4 = menu => {
    return (
      <>
        {menu}
        {isLoadingmade && <FixedLoader />}
      </>
    );
  };
  const renderMenu5 = menu => {
    return (
      <>
        {menu}
        {isLoadingsku && <FixedLoader />}
      </>
    );
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional - adds smooth scroll animation
    });
  };

  const handleChangeLimit = () => {
    setPage(1);
  };
  // useEffect(() => {
  //   if (inView && limit) {
  //     setCurrentPage(prev => prev + 1);
  //     SetIsLoadingTableData(true);
  //   }
  // }, [inView]);
  useEffect(() => {
    if (inView && limit && searchQuery === '') {
      setCurrentPage(prev => prev + 1);
      console.log('Current Page change :', currentPage, 'Now : 1');

      // SetIsLoadingTableData(true);
    }
  }, [inView]);
  const [dataGrid, setDataGrid] = useState(6);
  const dataaaaa = [
    { label: 'Extra Small', value: 3 },
    { label: 'Small', value: 4 },
    { label: 'Medium', value: 6 },
    { label: 'Large', value: 8 },
    { label: 'Extra large', value: 12 }
  ];
  const [openMenuBar, setOpenMenuBar] = useState(false);
  const [costingFor, setCostingFor] = useState({ for: 'factory', name: '' });
  const [buyerAllData, setBuyerAllData] = useState([]);
  useEffect(() => {
    const fetchData = async (endpoint, labelAttribute, valueAttribute) => {
      try {
        const {
          data: {
            meta: {
              pagination: { pageCount }
            }
          }
        } = await axios.get(`${globalIP}${endpoint}`);
        const requests = [];
        for (let page = 1; page <= pageCount; page++) {
          requests.push(axios.get(`${globalIP}${endpoint}?populate=*&pagination[page]=${page}`));
        }
        const responses = await Promise.all(requests);
        const data = responses
          .flatMap(response => response.data.data)
          .map(item => ({
            label: item.attributes[labelAttribute],
            value: item.attributes[valueAttribute]
          }));
        setBuyerAllData(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData('/api/buyer-details', 'buyernm', 'buyernm');
  }, [costingFor.for]);
  const [costingAllData, setCostingAllData] = useState([]);
  useLayoutEffect(() => {
    const fetchData = async () => {
      try {
        const {
          data: {
            meta: {
              pagination: { pageCount }
            }
          }
        } = await axios.get(`${globalIP}/api/costings?populate=*`);

        const allData = [];
        for (let page = 1; page <= pageCount; page++) {
          const response = await axios.get(
            `${globalIP}/api/costings?populate=*&pagination[page]=${page}`
          );
          allData.push(response.data);
        }
        setCostingAllData(allData.flatMap(item => item.data));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  const [tableHeight, setTableHeight] = useState(20); // Default height

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 290; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize

    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const [sortAlias, setSortAlias] = useState(false);
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />

      <div
        style={{
          justifyContent: 'space-between',
          width: '-webkit-fill-available',
          position: 'fixed',
          height: '185px',
          background: '#fff',
          zIndex: 1
        }}
      >
        <Stack
          className="table-toolbar main"
          style={{ paddingLeft: '0', paddingBottom: 0 }}
          justifyContent="space-between"
        >
          <Stack direction="column" alignItems="flex-start">
            <h3 className="title">Costing Insertion</h3>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={`/${ugr}/dashboard`}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/${ugr}/products`}>Product</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Costing Insertion</Breadcrumb.Item>
            </Breadcrumb>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          style={{ padding: '0 20px', marginTop: '-28px' }}
        >
          <Stack spacing={5} className={openMenuBar ? 'product-item' : 'mange-search'}>
            <HeaderFilter
              {...{
                head,
                label,
                //data states
                categorydata,
                productypedata,
                colordata,
                proNamedata,
                skudata,
                buyernamedata,
                finishdata,
                aliasdata,
                searchdata,
                proDdata,
                madedata,
                hsndata,
                materialdata,
                setCategorydata,
                setIsLoadingc,
                isLoadingc,
                SetIsLoadingTableData,
                setProgress,
                setColordata,
                isLoadingcolor,
                setIsLoadingcolor,
                setFinishdata,
                isLoadingfin,
                setIsLoadingfin,
                setHsndata,
                isLoadinghsn,
                setIsLoadinghsn,
                //selectedstates
                selectedCategory,
                selectedProductType,
                selectedColor,
                selectedpron,
                selectedsku,
                selectedBuyer,
                selectedFinish,
                selectedAlias,
                selectedSearch,
                selectedpd,
                selectedmade,
                selectedhsn,
                selectedmaterial,
                selectedDateRange,
                selectedUpdatedDateRange,
                //onchangehandlers
                handleCategoryChange,
                handleProductTypeChange,
                handleColorChange,
                handleProNameChange,
                handleSkuChange,
                handleBuyerChange,
                handleFinishChange,
                handleAliasChange,
                handleSearchChange,
                handleProDChange,
                handleMadeChange,
                handleHSNChange,
                handleMaterialChange,
                handleDatechange,
                handleUpdatedDatechange,
                //onopenfunctions
                fetchCategory,
                fetchColors,
                fetchFinishes,
                fetchProductTypes,
                fetchAlias,
                //rendermenus
                renderMenu2,
                renderMenu5,
                renderMenu1,
                renderMenu,
                renderMenu3,
                renderMenu4
              }}
            />
            <div id="custom-container" style={{ position: 'relative' }}>
              <SelectPicker
                searchable={false}
                data={[
                  { label: 'Buyer', value: 'buyer' },
                  { label: 'Factory', value: 'factory' }
                ]}
                style={{ width: 145 }}
                cleanable={false}
                value={costingFor?.for}
                onChange={value => setCostingFor(prev => ({ ...prev, for: value }))}
                placeholder="Costing for"
                container={() => document.getElementById('custom-container')}
              />
            </div>
            {costingFor.for == 'buyer' && (
              <div id="custom-container" style={{ position: 'relative' }}>
                <SelectPicker
                  data={buyerAllData}
                  style={{ width: 180 }}
                  value={costingFor?.name}
                  onChange={value => setCostingFor(prev => ({ ...prev, name: value }))}
                  placeholder="Costing for buyer"
                  container={() => document.getElementById('custom-container')}
                />
              </div>
            )}
            <Button appearance="default" active onClick={() => setShowDrawer(true)}>
              More Filter
            </Button>
            <Button
              appearance="default"
              active
              onClick={() => history(`/${ugr}/costing-view`, { state: buyerAllData })}
            >
              Costing View
            </Button>
          </Stack>
          <Stack spacing={5} style={{ marginTop: '25px' }}>
            {sort && <IconButton icon={<FunnelIcon />} active onClick={() => setSortAlias(true)} />}
            <InputGroup inside>
              <Input
                placeholder="Search"
                type="text"
                value={searchQuery}
                onChange={value => {
                  setSearchQuery(value);
                }}
                className="pdt-srch"
              />
              <InputGroup.Addon>
                <SearchIcon style={{ cursor: 'pointer' }} />
              </InputGroup.Addon>
            </InputGroup>

            <Stack>
              <ButtonToolbar className="data-grid">
                <SelectPicker
                  data={dataaaaa}
                  searchable={false}
                  style={{ width: 100 }}
                  placeholder="Grid"
                  onChange={e => setDataGrid(!e ? 6 : e)}
                />
                <ButtonGroup size="md">
                  <Whisper
                    placement="bottomEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={tooltip}
                  >
                    <IconButton
                      icon={<MenuIcon />}
                      active={isActive1}
                      className={
                        showtab == 2 ? 'btn btn-outline-secondary' : 'btn btn-outline-secondary'
                      }
                      onClick={() => setShowtab(2)}
                    />
                  </Whisper>
                  <Whisper
                    placement="bottomEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={tooltip1}
                  >
                    <IconButton
                      icon={<GridIcon />}
                      active={isActive2}
                      className={
                        showtab == 1 ? 'btn btn-outline-secondary ' : 'btn btn-outline-secondary '
                      }
                      onClick={() => setShowtab(1)}
                      id="bb"
                    />
                  </Whisper>
                </ButtonGroup>
              </ButtonToolbar>
            </Stack>
          </Stack>
        </Stack>
        <Divider className="divide" style={{ marginTop: '15px' }} />
      </div>
      {showtab == 1 ? (
        <Panel style={{ marginTop: '170px' }}>
          {(selectedCategory.length > 0 ||
            selectedProductType.length > 0 ||
            selectedColor.length > 0 ||
            selectedFinish.length > 0 ||
            selectedhsn.length > 0 ||
            selectedmaterial.length > 0 ||
            selectedBuyer.length > 0 ||
            selectedSearch.length > 0 ||
            selectedAlias.length > 0 ||
            selectedpron.length > 0 ||
            selectedpd.length > 0 ||
            selectedmade.length > 0 ||
            selectedsku.length > 0) && (
            <b style={{ marginLeft: '6px', marginBottom: '10px' }}>
              Total Products: {data123.length}/{meta123.pagination.total}
            </b>
          )}
          {/* {searchQuery && <b style={{ marginLeft: '6px' }}>Found Products: {foundProductCount}</b>} */}

          {selectedCategory.length === 0 &&
            selectedProductType.length === 0 &&
            selectedColor.length === 0 &&
            selectedFinish.length === 0 &&
            selectedhsn.length === 0 &&
            selectedmaterial.length === 0 &&
            selectedBuyer.length === 0 &&
            selectedSearch.length === 0 &&
            selectedAlias.length === 0 &&
            selectedpron.length === 0 &&
            selectedpd.length === 0 &&
            selectedmade.length === 0 &&
            selectedsku.length === 0 &&
            meta123 && (
              <b style={{ marginLeft: '6px', marginBottom: '10px' }}>
                Products: {data123.length}/{meta123.pagination.total}
              </b>
            )}
          <FlexboxGrid justify="start" style={{ textAlign: 'center' }} className="datatbl-img">
            {data123.map(item => {
              const data = costingAllData.filter(i => {
                return (
                  i.attributes.prdcd == item.attributes.ProductCode &&
                  i.attributes.ProductId == item.id
                );
              });

              return (
                <FlexboxGrid.Item
                  as={Col}
                  key={item.id}
                  colspan={24}
                  md={dataGrid}
                  className="data-tbl-img"
                  style={{ overflow: 'hidden' }}
                >
                  <div className="col-md-12">
                    <Panel
                      className="box"
                      bordered
                      bodyFill
                      onClick={() => handleNavigate(item)}
                      style={{ display: 'inline-block', width: '100%', height: '260px' }}
                    >
                      <img
                        src={`${ip}${item.attributes?.CoverImage?.data?.attributes?.url}`}
                        alt="Image"
                        className="imgp"
                        loading="lazy"
                        style={{objectFit:"contain",width:"100%"}}
                      />
                      <div className="overlay">Costing</div>
                      <Panel>
                        <b>Product : {item.attributes.ProductName} </b>
                        <div>
                          {data?.some(i => i.attributes?.costingfor == 'buyer') && (
                            <div className="tick"></div>
                          )}
                          {data?.some(i => i.attributes?.costingfor == 'factory') && (
                            <div className="tick2"></div>
                          )}
                          {data?.some(i => i.attributes?.costingfor == 'factory') &&
                            data?.some(i => i.attributes?.costingfor == 'buyer') && (
                              <div className="tick3"></div>
                            )}
                        </div>
                        <p>
                          {label[0]?.attributes?.AliasCode} : {item.attributes.ProductId}
                        </p>
                        <div className="show-Costing">
                          {/* {costingFor.for == 'factory' ? (
                              data?.some(i => i.attributes?.costingfor == 'factory') ? (
                                <>
                                  <span>
                                    USD :
                                    {
                                      data?.find(i => i.attributes?.costingfor == 'factory')
                                        .attributes.targetcostUSD
                                    }
                                  </span>
                                  <span>
                                    {
                                      data?.find(i => i.attributes?.costingfor == 'factory')
                                        .attributes.targetCost
                                    }
                                    : INR
                                  </span>
                                </>
                              ) : null
                            ) : null}
                            {costingFor.for == 'buyer' ? (
                              data?.some(
                                i =>
                                  i.attributes?.costingfor == 'buyer' &&
                                  i.attributes?.buyername == costingFor?.name
                              ) ? (
                                <>
                                  <span>USD : {
                                    data?.find(
                                      i =>
                                        i.attributes?.costingfor == 'buyer' &&
                                        i.attributes?.buyername == costingFor?.name
                                    )?.attributes?.targetcostUSD
                                    }</span>
                                  <span>
                                    {
                                      data?.find(
                                        i =>
                                          i.attributes?.costingfor == 'buyer' &&
                                          i.attributes?.buyername == costingFor?.name
                                      )?.attributes?.targetCost
                                    }
                                  </span>
                                </>
                              ) : data?.some(
                                  i =>
                                    i.attributes?.costingfor == 'factory' &&
                                    i.attributes?.buyername == ''
                                ) ? (
                                <>
                                  <span>
                                    USD :
                                    {
                                      data?.find(i => i.attributes?.costingfor == 'factory')
                                        .attributes.targetcostUSD
                                    }
                                  </span>
                                  <span>
                                    {
                                      data?.find(i => i.attributes?.costingfor == 'factory')
                                        ?.attributes?.targetCost
                                    }
                                    : INR
                                  </span>
                                </>
                              ) : (
                                null
                              )
                            ) : null} */}
                          {(costingFor.for === 'factory' ||
                            (costingFor.for === 'buyer' && !costingFor.name)) &&
                            data.some(i => i.attributes?.costingfor === 'factory') && (
                              <>
                                <span>
                                  USD :{' '}
                                  {
                                    data.find(i => i.attributes?.costingfor === 'factory')
                                      .attributes.targetcostUSD
                                  }
                                </span>
                                <span>
                                  {
                                    data.find(i => i.attributes?.costingfor === 'factory')
                                      .attributes.targetCost
                                  }{' '}
                                  : INR
                                </span>
                              </>
                            )}
                          {costingFor.for === 'buyer' &&
                            costingFor.name &&
                            data.some(
                              i =>
                                i.attributes?.costingfor === 'buyer' &&
                                i.attributes?.buyername === costingFor.name
                            ) && (
                              <>
                                <span>
                                  USD :{' '}
                                  {
                                    data.find(
                                      i =>
                                        i.attributes?.costingfor === 'buyer' &&
                                        i.attributes?.buyername === costingFor.name
                                    )?.attributes?.targetcostUSD
                                  }
                                </span>
                                <span>
                                  {
                                    data.find(
                                      i =>
                                        i.attributes?.costingfor === 'buyer' &&
                                        i.attributes?.buyername === costingFor.name
                                    )?.attributes?.targetCost
                                  }
                                  : INR
                                </span>
                              </>
                            )}
                        </div>
                      </Panel>
                    </Panel>
                  </div>
                </FlexboxGrid.Item>
              );
            })}
          </FlexboxGrid>
        </Panel>
      ) : null}
      {showtab == 1 ? (
        <>
          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
          {isLoadingTableData && data123.length && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100px'
              }}
            >
              <Loader size="md" content="Loading..." style={{ color: 'red' }} />
            </div>
          )}
          {isLoading && <Loader center size="md" speed="fast" content="loading..." />}
          <Stack justifyContent="flex-end">
            <IconButton
              size="sm"
              icon={<SortUpIcon />}
              active
              onClick={scrollToTop}
              style={{
                position: 'fixed',
                top: '90%',
                right: 10,
                transform: 'translateY(-50%)',
                zIndex: 9999
              }}
            />
          </Stack>
        </>
      ) : null}

      {showtab == 2 ? (
        <Panel className="row" style={{ marginTop: '172px' }}>
          {(selectedCategory.length > 0 ||
            selectedProductType.length > 0 ||
            selectedColor.length > 0 ||
            selectedFinish.length > 0 ||
            selectedhsn.length > 0 ||
            selectedmaterial.length > 0 ||
            selectedBuyer.length > 0 ||
            selectedSearch.length > 0 ||
            selectedAlias.length > 0 ||
            selectedpron.length > 0 ||
            selectedpd.length > 0 ||
            selectedmade.length > 0 ||
            selectedsku.length > 0) && (
            <b style={{ marginLeft: '6px' }}>
              Total Products: {data123.length}/{meta123.pagination.total}
            </b>
          )}

          {!searchQuery &&
            selectedCategory.length === 0 &&
            selectedProductType.length === 0 &&
            selectedColor.length === 0 &&
            selectedFinish.length === 0 &&
            selectedhsn.length === 0 &&
            selectedmaterial.length === 0 &&
            meta123 && (
              <b style={{ marginLeft: '6px' }}>Total Products: {meta123.pagination.total}</b>
            )}
          <Table
            className="row"
            virtualized
            wordWrap="break-word"
            shouldUpdateScroll={false}
            loading={isLoading}
            rowHeight={60}
            cellBordered
            style={{ position: 'sticky' }}
            data={
              noData
                ? []
                : tableData.filter(item => {
                    const ProductName = item.attributes.ProductName
                      ? item.attributes.ProductName.toLowerCase()
                      : '';
                    const AliasCode = item.attributes.ProductId
                      ? item.attributes.ProductId.toLowerCase()
                      : '';
                    const ColorName = item.attributes.ColorName
                      ? item.attributes.ColorName.toLowerCase()
                      : '';
                    const HSNCode = item.attributes.HSNCode
                      ? item.attributes.HSNCode.toLowerCase()
                      : '';
                    const CategoryName = item.attributes.CategoryName
                      ? item.attributes.CategoryName.toLowerCase()
                      : '';
                    const FinishName = item.attributes.FinishName
                      ? item.attributes.FinishName.toLowerCase()
                      : '';
                    const SearchKeyword = item.attributes.SearchKeyword
                      ? item.attributes.SearchKeyword.toLowerCase()
                      : '';
                    const MOQ = item.attributes.MOQ ? item.attributes.MOQ.toLowerCase() : '';
                    const ProductDesigner = item.attributes.ProductDesigner
                      ? item.attributes.ProductDesigner.toLowerCase()
                      : '';
                    const MadeBy = item.attributes.MadeBy
                      ? item.attributes.MadeBy.toLowerCase()
                      : '';
                    const ProductTypeName = item.attributes.ProductTypeName
                      ? item.attributes.ProductTypeName.toLowerCase()
                      : '';

                    return (
                      ProductName.includes(searchQuery.toLowerCase()) ||
                      AliasCode.includes(searchQuery.toLowerCase()) ||
                      ColorName.includes(searchQuery.toLowerCase()) ||
                      CategoryName.includes(searchQuery.toLowerCase()) ||
                      HSNCode.includes(searchQuery.toLowerCase()) ||
                      FinishName.includes(searchQuery.toLowerCase()) ||
                      SearchKeyword.includes(searchQuery.toLowerCase()) ||
                      MOQ.includes(searchQuery.toLowerCase()) ||
                      ProductDesigner.includes(searchQuery.toLowerCase()) ||
                      MadeBy.includes(searchQuery.toLowerCase()) ||
                      ProductTypeName.includes(searchQuery.toLowerCase())
                    );
                  })
            }
            height={tableHeight}
            rowKey="id"
            onRowClick={() => {}}
            bordered
          >
            {defaultColumns.map(column => {
              if (columnKeys.includes(column.key)) {
                const { key, label, headerCell, cell, ...rest } = column;
                return (
                  <Table.Column {...rest} key={key} align="center">
                    {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                    {cell || <CustomCell dataKey={key} />}
                  </Table.Column>
                );
              }
              return null;
            })}
          </Table>
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={['-', 'pager', 'skip']}
              total={tableMeta?.pagination?.total || 1}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </Panel>
      ) : null}

      <FilterDrawer
        {...{
          showDrawer,
          setShowDrawer,
          head,
          label,
          //data states
          categorydata,
          productypedata,
          colordata,
          proNamedata,
          skudata,
          buyernamedata,
          finishdata,
          aliasdata,
          searchdata,
          proDdata,
          madedata,
          hsndata,
          materialdata,
          setCategorydata,
          setIsLoadingc,
          isLoadingc,
          SetIsLoadingTableData,
          setProgress,
          setColordata,
          isLoadingcolor,
          setIsLoadingcolor,
          setFinishdata,
          isLoadingfin,
          setIsLoadingfin,
          setHsndata,
          isLoadinghsn,
          setIsLoadinghsn,
          setMaterialdata,
          isLoadingmat,
          setIsLoadingmat,
          //selectedstates
          selectedCategory,
          selectedProductType,
          selectedColor,
          selectedpron,
          selectedsku,
          selectedBuyer,
          selectedFinish,
          selectedAlias,
          selectedSearch,
          selectedpd,
          selectedmade,
          selectedhsn,
          selectedmaterial,
          selectedDateRange,
          selectedUpdatedDateRange,

          //onchangehandlers
          handleCategoryChange,
          handleProductTypeChange,
          handleColorChange,
          handleProNameChange,
          handleSkuChange,
          handleBuyerChange,
          handleFinishChange,
          handleAliasChange,
          handleSearchChange,
          handleProDChange,
          handleMadeChange,
          handleHSNChange,
          handleMaterialChange,
          handleDatechange,
          handleUpdatedDatechange,

          //onopenfunctions
          fetchCategory,
          fetchColors,
          fetchFinishes,
          fetchProductTypes,
          fetchAlias,
          fetchHsn,
          fetchMaterials,
          //rendermenus
          renderMenu2,
          renderMenu5,
          renderMenu1,
          renderMenu,
          renderMenu3,
          renderMenu4
        }}
      />
      {sortAlias && (
        <SortDrawer
          sortAlias={sortAlias}
          setSortAlias={setSortAlias}
          alsort={alsort}
          setAlsort={setAlsort}
        />
      )}
      <Stack justifyContent="flex-end"></Stack>

      <Stack
        className="copyright"
        justifyContent="flex-end"
        spacing={5}
        style={{
          position: 'fixed',
          bottom: '0',
          width: '-webkit-fill-available',
          textAlign: 'center',
          backgroundColor: 'white',
          paddingRight: '16px'
        }}
      >
        <p>© All Right Reserved. Product by </p>
        <p>
          {' '}
          <a href="https://erpdaddy.com/" target="_blank">
            ERPDaddy Software Solution.
          </a>
        </p>
      </Stack>
    </>
  );
};
export default React.memo(ProductSelectionPage);
